<div class="invoices-container">
  <div class="filters-container">
    <div class="filter-item">
      <label i18n="@@conversations.filter.status">Status</label>
      <p-multiSelect
        [(ngModel)]="selectedStatuses"
        [options]="statusOptions"
        optionLabel="label"
        optionValue="value"
        i18n-placeholder="@@invoices.allStatuses"
        placeholder="All Statuses"
        (onChange)="onFilterChange()"
        styleClass="filter-select"
      />
    </div>
    <div class="filter-item">
      <label i18n="@@invoices.paymentStatus">Payment Status</label>
      <p-multiSelect
        [(ngModel)]="selectedPaymentStatuses"
        [options]="paymentStatusOptions"
        optionLabel="label"
        optionValue="value"
        i18n-placeholder="@@invoices.allPaymentStatuses"
        placeholder="All Payment Statuses"
        (onChange)="onFilterChange()"
        styleClass="filter-select"
      />
    </div>
    <div class="filter-item">
      <label i18n="@@invoices.showOverdue">Show Overdue</label>
      <p-toggleSwitch
        [(ngModel)]="showOverdue"
        (onChange)="onFilterChange()"
      />
    </div>
  </div>

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner class="loading-spinner"></p-progressSpinner>
      <p i18n="@@invoices.loading">Loading invoices...</p>
    </div>
  } @else {
    <p-table [value]="invoices()" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template #header>
        <tr>
          <th [style.width]="'25%'" i18n="@@invoices.col.number">Invoice #</th>
          <th class="hide-mobile" i18n="@@invoices.col.issueDate">Issue Date</th>
          <th class="hide-mobile" i18n="@@invoices.col.dueDate">Due Date</th>
          <th class="hide-mobile" i18n="@@invoices.col.amount">Amount</th>
          <th [style.width]="'15%'" i18n="@@invoices.paymentStatus">Payment Status</th>
          <th [style.width]="'10%'" class="hide-mobile" i18n="@@invoices.col.overdue">Overdue</th>
          <th [style.width]="'10%'" i18n="@@campaignItems.col.actions">Actions</th>
        </tr>
      </ng-template>
      <ng-template #body let-invoice>
        <tr>
          <td>
            <span class="invoice-number-desktop">{{ invoice.number || 'N/A' }}</span>
            <span
              class="invoice-number-mobile"
              [pTooltip]="invoice.number || 'N/A'"
              tooltipPosition="top"
            >
              {{ invoice.number }}
            </span>
          </td>
          <td class="hide-mobile">{{ formatDate(invoice.issuing_date) }}</td>
          <td class="hide-mobile">{{ formatDate(invoice.payment_due_date) }}</td>
          <td class="hide-mobile">{{ formatAmount(invoice.total_amount_cents, invoice.currency) }}</td>
          <td>
            <p-tag
              [value]="getPaymentStatusLabel(invoice.payment_status)"
              [severity]="getPaymentStatusSeverity(invoice.payment_status)"
            />
          </td>
          <td class="hide-mobile">
            @if (invoice.payment_overdue) {
              <p-tag [value]="overdueLabel" severity="danger" />
            }
          </td>
          <td>
            <div class="action-buttons">
              @if (invoice.file_url) {
                <p-button
                  icon="pi pi-download"
                  [text]="true"
                  [rounded]="true"
                  severity="secondary"
                  (onClick)="downloadInvoice(invoice)"
                  i18n-pTooltip="@@invoices.download"
                  pTooltip="Download Invoice"
                  tooltipPosition="top"
                  i18n-ariaLabel="@@invoices.download"
                  ariaLabel="Download Invoice" />
              }
              @if (shouldShowPayButton(invoice)) {
                <p-button
                  icon="pi pi-credit-card"
                  [text]="true"
                  [rounded]="true"
                  severity="primary"
                  (onClick)="payInvoice(invoice)"
                  [loading]="generatingPaymentUrl() === invoice.lago_id"
                  i18n-pTooltip="@@invoices.payNow"
                  pTooltip="Pay Now"
                  tooltipPosition="top"
                  i18n-ariaLabel="@@invoices.payNow"
                  ariaLabel="Pay Now" />
              }
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="7" class="empty-message" i18n="@@invoices.empty">
            No invoices found
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
